<template>
  <div id="header">
    <div class="title">
      <div class="item" v-for="(item, index) in titleList" :key="index">
        <div :class="item.class" @click="titleClick(index)">
          {{ item.title }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import eventBus from '@/utils/event_bus';
export default {
  name: "HeaderLayout",
  data() {
    return {
      titleList: [
        { num: 1, class: "text tetx-select", title: "首页" },
        { num: 2, class: "text", title: "协会资讯" },
        { num: 3, class: "text", title: "办事指南" },
        { num: 4, class: "text", title: "政策法规" },
        { num: 5, class: "text", title: "加入会员" },
      ],
      titleClass: {
        default: "text",
        select: "text tetx-select",
      },
    };
  },
  methods: {
    titleClick(index) {
      // if(index==4){
      //   window.open('https://duud.cn/app/index.php?i=767&c=entry&do=detail&m=tech_superarticle&id=324','_blank');
      //   return;
      // }
      this.titleList.forEach((el) => {
        el.class = this.titleClass.default;
      });
      this.titleList[index].class = this.titleClass.select;
      this.$router.push({ name: "home", query: { idx: index + 1 } });
    },
  },
  mounted() {
    eventBus.$on('navChange', (idx) => {
      let index = idx - 1;
      this.titleList.forEach((el) => {
        el.class = this.titleClass.default;
      });
      this.titleList[index].class = this.titleClass.select;
    });
    console.info('this.$route.query.idx:',this.$route.query.idx)
    let index = (this.$route.query.idx ? this.$route.query.idx - 1 : 0);
    
    this.titleList.forEach((el) => {
      el.class = this.titleClass.default;
    });
    this.titleList[index].class = this.titleClass.select;
  },
};
</script>

<style scoped>
@import "../style/header.css";
</style>